import { Text } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { IconMath, Tag } from 'ui'
import { CardItem } from './CardItem'
import { CardLine } from './CardLine'
import { messages } from './messages'

const OPERATIONS = [
  {
    description: messages.operation.sum,
    operation: '+',
  },
  {
    description: messages.operation.subtraction,
    operation: '-',
  },
  {
    description: messages.operation.multiplication,
    operation: '*',
  },
  {
    description: messages.operation.division,
    operation: '/',
  },
]

export function OperationsCard() {
  const { $t } = useIntl()

  return (
    <CardItem
      name="operations"
      icon={<IconMath />}
      title={$t(messages.operation.title)}
      link={$t(messages.operation.link)}
    >
      {OPERATIONS.map(({ description, operation }, index) => (
        <CardLine columns="split" key={index}>
          <div>
            <Tag>{operation}</Tag>
          </div>
          <Text>
            <FormattedMessage {...description} />
          </Text>
        </CardLine>
      ))}
    </CardItem>
  )
}
